/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import MDInput from "components/MDInput";
import MDPopup from "components/MDPopup";
import MDAlert from "components/MDAlert";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

import { Link } from "react-router-dom";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import Icon from "@mui/material/Icon";


import TvCreate from "./tvCreate";

import TvDocAttach from "./tvDocAttach";

import { useAuthContext } from "../../../hooks/useAuthContext";

import { httpGet, httpPost, httpDelete } from "../../../api";

import {formatDate, DownloadFile} from "../../../utils"

const Tables = (props) => {

  const endPoint = "/tv";

  const { user } = useAuthContext();

  const columns = [
      { Header: "Ref ID", accessor: "id", align: "center" },
      { Header: "Model Name", accessor: "model", align: "center" },
      { Header: "Lot Number", accessor: "lot", align: "center" },
      { Header: "Action", accessor: "action", align: "center" },
    ]

  const [ rows, setRows ] = useState([]);

  const [ TableData, setTableData ] = useState([]);

  const [ refrechedData, setRefrechedData ] = useState(true);


  const handleDelete = async (tv_id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) {
      return;
    }

    const response = await httpDelete(process.env.REACT_APP_URL_BASE + "/tv/delete/" + tv_id);

    if (response.status != 200) {
      alert("Something went wrong");
    }else{
      setRefrechedData(true);
    }
  }

  useEffect(() => {
    const fetchData = async () => {
        const response = await httpGet(process.env.REACT_APP_URL_BASE + endPoint);
        
        if (response.status != 200){
            return
        }

        setTableData(await response.json());

        setCurrentModel(false);

        setRefrechedData(!refrechedData);
    }

    if (refrechedData) {
      fetchData();
    }
  }, [refrechedData])

  useEffect(() => {
    setRows(TableData.map((row) => {

          const action = [];

          action.push(
            <MDButton variant="contained" color="error" size="small" sx={{marginLeft: ".5em"}} onClick={(e) => {handleDelete(row.id)}} >Delete</MDButton>
              )

          action.push(
            <MDButton variant="outlined" color="info" size="small" sx={{marginLeft: ".5em"}} onClick={(e) => {handleEdit(row.id)}} >Edit</MDButton>
              )

          action.push(
            <MDButton variant="outlined" color="warning" size="small" sx={{marginLeft: ".5em"}} onClick={(e) => {handleAttach(row.id)}} >Attach</MDButton>
              )

     
          return {
            id: row.id,
            model: row.model,
            lot: row.lot,
            action: action

          }
        }))
      
  }, [TableData])


  const [openCreate, setOpenCreate] = useState(false);

  const [currentModel, setCurrentModel] = useState({
    id: 0,
    model: "",
    lot: "",
  });

  const handleCloseCreate = () => {
    setOpenCreate(false);
    setCurrentModel({
      id: null,
      model: "",
      lot: "",
    })
  }

  const handleEdit = (tv_id) => {
    setCurrentModel(TableData.find((tv) => tv.id == tv_id));
    setOpenCreate(true);
  }

  const handleAttach = (tv_id) => {
    setCurrentModel(TableData.find((tv) => tv.id == tv_id)); 
    setOpenAttach(true);
  }

  const [openAttach, setOpenAttach] = useState(false);

  const handleCloseAttach = () => {
    setOpenAttach(false);
  }

  return (
    <DashboardLayout>

      <TvCreate open={openCreate} close={handleCloseCreate} setRefreshed={setRefrechedData} model={currentModel} />

      <TvDocAttach open={openAttach} close={handleCloseAttach} model={currentModel} setRefreshed={setRefrechedData} />


      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="error"
                borderRadius="lg"
                coloredShadow="info"

                sx={{width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center"}}
              >
                <MDTypography variant="h6" color="white">
                  List of Televisions
                </MDTypography>

                <MDButton variant="gradient" color="success" onClick={() => {setOpenCreate(true)}}>
                  Create
                </MDButton>
              </MDBox>

              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  entriesPerPage={true}
                  showTotalEntries={true}
                  noEndBorder
                  canSearch
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
